@use '../../../common/styles/mixins.scss';
@use '../../../common/styles/flexMixins.scss';
.lastWeekAlarmsNumber {
  //font-weight: 600;
  align-items: center;
}
